<template>
  <div>
    <top-title
      name="优惠券管理"
      button1="添加外部优惠券"
      @myEvent="setCoupon"
      pageName="忠诚度管理-优惠券管理"
      button2="创建商品优惠券"
      button3="创建店铺优惠券"
      style="margin: 20px; min-width: 1066px"
    ></top-title>
    <div class="integralEden">
      <div class="content">
        <!-- 头部导航切换 -->
        <div class="navTab">
          <span class="tab" :class="{ active: tabActive == 1 }" @click="insideBtn">内部优惠券</span>
          <span class="tab" :class="{ active: tabActive == 2 }" @click="external">外部优惠券</span>
        </div>
        <!-- 内部优惠券 -->
        <div v-if="tabActive == 1">
          <input-form
            ref="inputForm"
            v-if="tabActive == 1"
            style="margin: 40px 0"
            :inputData="inputData"
            :pageName="pageName"
            :btnPosition1="true"
            @toParentVal="searchContent"
          ></input-form>

          <el-table
            :data="tableData"
            v-loading="tableLoading"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 95%; margin: 0 auto"
          >
            <template slot="empty">
              <div>
                <img class="no_goods_img" src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="name" label="优惠券名称"> </el-table-column>
            <el-table-column label="领取时间" width="240">
              <template slot-scope="scope">
                <span>起:{{ scope.row.takeBeginTime }}</span
                ><br />
                <span>止:{{ scope.row.takeEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期" width="240">
              <template slot-scope="scope">
                <span>起:{{ scope.row.beginTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数据统计" width="180">
              <template slot-scope="scope">
                <span>发行量:{{ scope.row.num }}</span> 张<br />
                <span>发券量:{{ scope.row.sendNum }}</span> 张<br />
                <span>用券量:{{ scope.row.usedNum }}</span> 张<br />
                <span style="color: #7f85e9; cursor: pointer" @click="moreStatistics" v-zoom="{ from: pageName, name: '更多统计' }">更多统计</span>
              </template>
            </el-table-column>
            <el-table-column label="面额/使用条件">
              <template slot-scope="scope">
                <span>{{ scope.row.discount }}</span
                >元/ 满<span>{{ scope.row.quota }}</span
                >元
              </template>
            </el-table-column>
            <el-table-column label="推广范围" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.grantType == 1">促销绑定</span>
                <span v-if="scope.row.grantType == 2">推送</span>
                <span v-if="scope.row.grantType == 3">免费领取</span>
                <span v-if="scope.row.grantType == 4">京豆换券</span>
                <span v-if="scope.row.grantType == 5">互动平台 </span>
              </template>
            </el-table-column>
            <el-table-column label="优惠券链接" width="350">
              <template slot-scope="scope">
                无线连接
                <el-input v-model="scope.row.longLinkUrl" readonly style="width: 220px; margin-left: 15px"></el-input><br />
                无线短连接
                <el-input v-model="scope.row.shortLinkUrl" readonly style="width: 220px"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
          <div style="color: #fe4d45; padding: 20px 0 20px 40px">
            <!-- 注：此类型奖品暂时不支持自营店铺 -->
          </div>
        </div>

        <!-- 外部优惠券 -->
        <div v-if="tabActive == 2">
          <input-form
            v-if="tabActive == 2"
            ref="inputForms"
            style="margin: 40px 0"
            :inputData="inputDataTwo"
            :btnPosition1="true"
            @toParentVal="searchContentTwo"
          ></input-form>

          <el-table
            :data="tableDataTwo"
            v-loading="tableLoading"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 95%; margin: 0 auto"
          >
            <template slot="empty">
              <div>
                <img class="no_goods_img" src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="name" label="优惠券名称"> </el-table-column>
            <el-table-column label="领取时间">
              <template slot-scope="scope">
                <span>起:{{ scope.row.takeBeginTime }}</span
                ><br />
                <span>止:{{ scope.row.takeEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期">
              <template slot-scope="scope">
                <span>起:{{ scope.row.beginTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="面额/使用条件">
              <template slot-scope="scope">
                <span>{{ scope.row.discount }}</span
                >元/ 满<span>{{ scope.row.quota }}</span
                >元
              </template>
            </el-table-column>
            <el-table-column label="优惠券链接" width="400">
              <template slot-scope="scope">
                无线连接
                <el-input v-model="scope.row.shortUrl" readonly style="width: 220px; margin-left: 14px"></el-input><br />
                无线短连接
                <el-input v-model="scope.row.url" readonly style="width: 220px"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="formListTwo.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="formListTwo.size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalListTwo"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加优惠券弹窗 -->
    <el-dialog title="添加外部优惠券" :visible.sync="dialogFormVisible" :before-close="closeWithoutCoupon">
      <el-form :model="setFormList" label-width="150px">
        <el-form-item label="putKey:">
          <el-input v-model="setFormList.putKey" style="width: 300px;margin-right:10px;"></el-input>
          <el-button type="primary" @click="byPutKey">检测可用性</el-button>
          <div style="color:#e2455b;">注：自营商家可自己申请或找采销申请且必须为免费领取型优惠券，复制putKey</div>
        </el-form-item>
        <el-form-item label="优惠券名称:">
          <el-input v-model="setFormList.name" style="width: 300px"></el-input>
        </el-form-item>
        <!-- <el-form-item label="活动配置Key或链接:">
          <el-input
            v-model="setFormList.skuId"
            style="width: 300px; margin-right: 50px"
          ></el-input>
          <el-button type="primary">检查可用性</el-button><br />
          <span style="font-size: 12px; color: #fe4d45"
            >注：商家可自己申请或找采销申请且必须为免费领取型优惠券，复制putKey</span
          >
        </el-form-item> -->
        <el-form-item label="有效期:">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="setFormList.startTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 135px; font-size: 12px"
              @change="TimeSendTimeOne"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="setFormList.endTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              @change="TimeSendTimeOne"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 150px; font-size: 12px"
              class="time2"
              :clearable="false"
            ></el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          &nbsp;&nbsp;有效期为：<span style="color: #fe4d45">{{ TimeSendTimeOne1 }} </span>天
        </el-form-item>
        <el-form-item label="领取时间:">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="setFormList.takeBeginTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              @change="TimeSendTimeTwo"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 135px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="setFormList.takeEndTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              @change="TimeSendTimeTwo"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 150px; font-size: 12px"
              class="time2"
              :clearable="false"
            ></el-date-picker>
            <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime1()"></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
          &nbsp;&nbsp;有效期为：<span style="color: #fe4d45">{{ TimeSendTimeTwo1 }} </span>天
        </el-form-item>
        <el-form-item label="优惠券面额:">
          <el-input
            onkeyup="value=value.replace(/[^\d]/g,'')"
            v-model="setFormList.discount"
            @change="discountchange"
            style="width: 300px"
          ></el-input>
          &nbsp;&nbsp;元
        </el-form-item>
        <el-form-item label="参加条件">
          <el-radio-group v-model="resource" @change="resourceChange">
            <el-radio label="无条件"></el-radio>
            <el-radio label="订单满"></el-radio>
            <el-input v-model="quota" onkeyup="value=value.replace(/[^\d]/g,'')" @change="quotaChange" style="width: 150px"></el-input>
            <span>元</span>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="PC端链接:">
          <el-input v-model="setFormList.url" style="width: 300px" @change="urlChange"></el-input>
          &nbsp;&nbsp;外部优惠券链接
        </el-form-item>
        <el-form-item label="无线端链接:">
          <el-input v-model="setFormList.shortUrl" style="width: 300px" @change="shortUrlChange"></el-input>
          &nbsp;&nbsp;PC端链接输入后会自动转化无线端优惠券，请确认是否正确
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeWithoutCoupon">取 消</el-button>
        <el-button type="primary" @click="addWithoutCoupon">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topTitle from "../../components/top-title";
import inputForm from "../../components/inputForm";
import { couponList } from "@/api/integralCenter/prizeCenter.js";
import { querySellerCouponExternalList, addExternal, byPutKey } from "@/api/integralCenter/couponWriteController";
export default {
  components: {
    topTitle,
    inputForm,
  },
  data() {
    return {
      // pageName:"忠诚度管理-优惠券管理",
      dialogFormVisible: false,
      tabActive: 1,
      totalList: 0,
      totalListTwo: 0,
      tableLoading: true,
      currentPage: 1,
      tableData: [],
      tableDataTwo: [],
      setFormList: {
        discount: "",
        endTime: "",
        name: "",
        quota: 0,
        shortUrl: "",
        startTime: "",
        url: "",
        takeBeginTime: "",
        takeEndTime: "",
      },
      quota: "",
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
        // isLink: true,
        // isFilter: true,
      },
      resource: "无条件", //添加外部优惠卷参加条件
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      inputData: [
        {
          name: "优惠券:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券面额:",
          val: "discount",
          placeholder: "请输入",
        },
        {
          name: "有效期:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "优惠券类型:",
          val: "type",
          placeholder: "请选择",
          selectArr: [
            { label: "东券", id: 1 },
            { label: "京券", id: 0 },
          ],
        },
        {
          name: "优惠券发放类型:",
          val: "grantType",
          placeholder: "请选择",
          selectArr: [
            { label: "促销绑定", id: 1 },
            { label: "推送", id: 2 },
            { label: "免费领取", id: 3 },
            { label: "京豆换券", id: 4 },
            // { label: "互动平台", id: 5 },
          ],
        },
        {
          name: "优惠券是否公开:",
          val: "display",
          placeholder: "请选择",
          selectArr: [
            { label: "公开", id: 3 },
            { label: "不公开", id: 1 },
          ],
        },
      ],
      TimeSendTimeOne1: 0, //有效期
      TimeSendTimeTwo1: 0, //领取时间
      inputDataTwo: [
        {
          name: "优惠券:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券面额:",
          val: "discount",
          placeholder: "请输入",
        },
        {
          name: "有效期:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      //   // this.quireList();
      //   console.log(this.$refs.inputForm);
      this.$refs.inputForm.formSearch();
    });
    this.estimate();
  },
  computed: {
    pageName: function() {
      if (this.tabActive == 1) {
        return "忠诚度管理-优惠券管理-内部优惠券";
      }
      if (this.tabActive == 2) {
        return "忠诚度管理-优惠券管理-外部优惠券";
      }
    },
  },
  methods: {
    // aaa() {
    //   console.log(this.setFormList.resource);
    // },
    //计算领取时间时间
    TimeSendTimeOne() {
      if (this.setFormList.startTime != "" && this.setFormList.endTime != "") {
        const end = Date.parse(new Date(this.setFormList.endTime));
        const now = Date.parse(new Date(this.setFormList.startTime));
        if (end < now) {
          this.$message.error("选择时间错误");
          // this.clearTimeSendTime();
          this.setFormList.endTime = "";
          this.setFormList.startTime = "";
        } else {
          const msec = end - now;
          let time = parseInt(msec / 1000 / 60 / 60);
          let day = parseInt(msec / 1000 / 60 / 60 / 24);
          if (time < 24) {
            this.TimeSendTimeOne1 = 1;
          } else {
            this.TimeSendTimeOne1 = day;
          }
        }
      }
    },
    //计算时间
    TimeSendTimeTwo() {
      if (this.setFormList.takeBeginTime != "" && this.setFormList.takeEndTime != "") {
        const end = Date.parse(new Date(this.setFormList.takeEndTime));
        const now = Date.parse(new Date(this.setFormList.takeBeginTime));
        if (end < now) {
          this.$message.error("选择时间错误");
          // this.clearTimeSendTime();
          this.setFormList.takeEndTime = "";
          this.setFormList.takeBeginTime = "";
        } else {
          const msec = end - now;
          let time = parseInt(msec / 1000 / 60 / 60);
          let day = parseInt(msec / 1000 / 60 / 60 / 24);
          if (time < 24) {
            this.TimeSendTimeTwo1 = 1;
          } else {
            this.TimeSendTimeTwo1 = day;
          }
        }
      }
    },
    //判断是否跳转
    estimate() {
      // console.log(this.$route.query.length.to);
      console.log("this.$router", this.$route);
      if (this.$route.query.to != undefined) {
        this.tabActive = 2;
        // this.dataAtatisticsId = this.$route.query.to;
        // this.dataStatisticsContent.hotSaleId = this.dataAtatisticsId;
        this.querySellerCouponExternal();
      }
    },
    //参加条件变化
    resourceChange(val) {
      if (val == "无条件") {
        this.setFormList.quota = 0;
        this.quota = "";
      } else if (val == "订单满") {
        this.setFormList.quota = this.quota;
        console.log(this.quota);
      }
      console.log(this.setFormList.quota);
    },
    //pc端链接
    urlChange() {
      let path = this.setFormList.url.split("?");
      if (path.length == 1) {
        this.setFormList.shortUrl = `http://coupon.m.jd.com/coupons/show.action`;
      } else if (path.length == 2) {
        this.setFormList.shortUrl = `http://coupon.m.jd.com/coupons/show.action?${path[1]}`;
      }
    },
    //无线端链接
    shortUrlChange() {
      if (setFormList.url == "") {
        this.$message.warning("请输入Pc端链接");
        setFormList.shortUrl = "";
      }
    },
    //获取优惠券数据
    quireList() {
      this.tableLoading = true;
      couponList(this.formList).then((res) => {
        this.tableLoading = false;
        // console.log(res, "res");
        this.tableData = res.data.records;
        this.totalList = Number(res.data.total);
      });
    },
    //优惠券面额
    discountchange(val) {
      this.setFormList.discount = val.replace(/[^\d]/g, "");
    },
    //优惠券参加条件
    quotaChange(val) {
      this.quota = val.replace(/[^\d]/g, "");
    },
    moreStatistics() {
      window.open("https://prom.shop.jd.com/bdp/execute.action?queryConponData.couponId=131789594&bindType=1");
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      console.log(this.formListTwo);
      querySellerCouponExternalList(this.formListTwo)
        .then((res) => {
          this.tableDataTwo = res.data.records;
          this.totalListTwo = Number(res.data.total);
          this.tableLoading = false;
        })
        .catch((res) => {});
    },
    //取消添加外部优惠
    closeWithoutCoupon() {
      this.dialogFormVisible = false;
      this.$message.warning("已取消添加外部优惠卷");
      this.clearAddCoupon();
    },
    clearAddCoupon() {
      this.setFormList = {
        discount: "",
        endTime: "",
        name: "",
        quota: 0,
        shortUrl: "",
        startTime: "",
        url: "",
        takeBeginTime: "",
        takeEndTime: "",
        putkey: "",
      };
      this.quota = "";
      this.TimeSendTimeOne1 = 0; //有效期
      this.TimeSendTimeTwo1 = 0; //领取时间
    },
    //确定添加外部优惠券
    addWithoutCoupon() {
      if (this.resource == "订单满") {
        this.setFormList.quota = this.quota;
      }
      // return;
      this.addExternalOne();
    },
    //添加外部优惠券
    addExternalOne() {
      addExternal(this.setFormList)
        .then((res) => {
          if (res.code == 1) {
            this.dialogFormVisible = false;
            this.querySellerCouponExternal();
            this.clearAddCoupon();
            this.$message.success("添加成功");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    insideBtn() {
      this.tabActive = 1;
      // this.quireList();
      this.$nextTick(() => {
        console.log(this.$refs.inputForm);
        this.$refs.inputForm.initVal();
        this.$refs.inputForm.formSearch();
      });
    },
    external() {
      this.tabActive = 2;
      this.$nextTick(() => {
        console.log(this.$refs.inputForms);
        this.$refs.inputForms.initVal();
        this.$refs.inputForms.formSearch();
      });
      // setTimeout(()=>{
      // this.querySellerCouponExternal();

      // },500)
    },
    //内部优惠券查询
    searchContent(val) {
      // console.log(val, 111);
      this.formList.current = 1;
      this.formList.name = val.name;
      this.formList.discount = val.discount;
      this.formList.beginTime = val.beginTime;
      this.formList.endTime = val.endTime;
      this.formList.type = val.type;
      this.formList.grantType = val.grantType;
      this.formList.display = val.display;
      console.log(this.formList);
      // return
      this.quireList();
    },
    //外部优惠券查询
    searchContentTwo(val) {
      console.log(val);
      this.formListTwo.current = 1;
      this.formListTwo.name = val.name;
      this.formListTwo.discount = val.discount;
      this.formListTwo.beginTime = val.beginTime;
      this.formListTwo.endTime = val.endTime;
      this.querySellerCouponExternal();
    },
    //创建
    setCoupon() {
      // console.log(1111);
      this.dialogFormVisible = true;
    },
    //分页变化事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handleSizeChange2(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChange2(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    clearTimeSendTime() {
      this.setFormList.startTime = "";
      this.setFormList.endTime = "";
      this.TimeSendTimeOne1 = 0;
    },
    clearTimeSendTime1() {
      this.setFormList.takeBeginTime = "";
      this.setFormList.takeEndTime = "";
      this.TimeSendTimeTwo1 = 0;
    },
    // 检测putKey可用性
    byPutKey() {
      byPutKey(this.setFormList.putKey).then((res) => {
        if (res.code == 1) {
          this.setFormList.endTime = res.data.endTime;
          this.setFormList.startTime = res.data.beginTime;
          this.setFormList.takeBeginTime = res.data.activityBeginTime;
          this.setFormList.takeEndTime = res.data.activityEndTime;
          this.setFormList.name = res.data.couponTitle;
          this.setFormList.discount = res.data.discount;
          this.setFormList.quota = res.data.quota;
          this.quota = res.data.quota;

          if (res.data.quota) {
            this.resource = "订单满";
          } else {
            this.resource = "无条件";
          }

          this.TimeSendTimeOne();
          this.TimeSendTimeTwo();

          this.$message.success("成功");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1110px;
  .content {
    // min-height: 980px;
    margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      .tab {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #fe4d45;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #fe4d45;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
      }
    }
    .pagination {
      margin: 40px 80px 0 0;
      text-align: right;
    }
  }
}
</style>
